import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { QCAcceptConfirmDialogComponent } from './qc-accept-confirm-dialog.component';
import { QCAcceptConfirmDialogConfig } from './model';

@Injectable()
export class QCAcceptConfirmDialogService {
    constructor(private readonly _dialogService: DialogService) {}

    open(config: QCAcceptConfirmDialogConfig): DynamicDialogRef {
        return this._dialogService.open(QCAcceptConfirmDialogComponent, {
            header: '质检确认',
            modal: true,
            draggable: false,
            resizable: false,
            data: config,
        });
    }
}
